import Image from 'next/image';
import { useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import { AccordionListStyle } from '../../../styles/components/common/blocks';

export interface IAccordionListItem {
  language?: string;
  title: string;
  content: string;
  expanded?: boolean;
}

export interface IAccordionListProps {
  title?: string;
  items: IAccordionListItem[];
}

const AccordionList = (props: IAccordionListProps) => {
  const [faqs, setFaqs] = useState(() =>
    props.items.map((faq, index) => ({
      ...faq,
      expanded: index === 0,
    }))
  );

  const handleToggle = (
    index: number,
    event: React.SyntheticEvent<HTMLDetailsElement>
  ) => {
    const isOpen = event.currentTarget.open;
    setFaqs((prevFaqs) =>
      prevFaqs.map((faq, i) =>
        i === index ? { ...faq, expanded: isOpen } : faq
      )
    );
  };

  useEffect(() => {
    setFaqs(
      props.items.map((faq, index) => ({
        ...faq,
        expanded: index === 0,
      }))
    );
  }, [props.items]);

  return (
    <div className={AccordionListStyle['accordion-list']}>
      {props.title && (
        <div
          className={`${AccordionListStyle['accordion-list-heading']} is-text-align-center`}>
          <ReactMarkdown>{props.title}</ReactMarkdown>
        </div>
      )}

      {faqs.map((faq, index) => (
        <details
          key={index}
          open={faq.expanded}
          onToggle={(e) => handleToggle(index, e)}
          className={AccordionListStyle['accordion-list-item']}>
          <summary className={AccordionListStyle['accordion-list-item-header']}>
            <span
              className={
                AccordionListStyle['accordion-list-item-header-icon-wrapper']
              }>
              <Image
                quality={90}
                src="/assets/images/icons/CollapseIcon.svg"
                alt="Expand icon"
                width={26}
                height={26}
                className={
                  faq.expanded
                    ? AccordionListStyle[
                        'accordion-list-item-header-icon-visible'
                      ]
                    : AccordionListStyle[
                        'accordion-list-item-header-icon-hidden'
                      ]
                }
              />
              <Image
                quality={90}
                src="/assets/images/icons/ExpandIcon.svg"
                alt="Collapse icon"
                width={26}
                height={26}
                className={
                  !faq.expanded
                    ? AccordionListStyle[
                        'accordion-list-item-header-icon-visible'
                      ]
                    : AccordionListStyle[
                        'accordion-list-item-header-icon-hidden'
                      ]
                }
              />
            </span>
            <span>{faq.title}</span>
          </summary>
          <div
            className={`${AccordionListStyle['accordion-list-item-content']} ${
              faq.expanded
                ? AccordionListStyle['accordion-list-item-content-expanded']
                : ''
            }`}>
            <ReactMarkdown>{faq.content}</ReactMarkdown>
          </div>
        </details>
      ))}
    </div>
  );
};

export default AccordionList;
